module.exports = __webpack_public_path__ + "static/img/saveSuccess.c1d9d3c8.png";